import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import {
  CheckCargoById,
  CheckCargoByIdRequest,
  CheckCargosResult,
} from "../../domain/usecases/check-cargo-by-id";
import { InvalidFieldError } from "../../validation/errors";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbCheckCargoById implements CheckCargoById {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async check(request: CheckCargoByIdRequest): Promise<CheckCargosResult> {
    const response = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: request,
    });

    switch (response.statusCode) {
      case HttpStatusCode.ok:
        return response.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      case HttpStatusCode.badRequest:
        throw new InvalidFieldError();
      default:
        throw new UnexpectedError();
    }
  }
}
